module.exports = __webpack_public_path__ + "img/yellow_right.1347bee3.svg";